import { Flex } from '@chakra-ui/react';
import * as _ from 'lodash';
import React from 'react';

import { useCreditFacilityContext } from 'packages/credit-facility/hooks/CreditFacilityProvider';
import { chartGroupMap } from 'packages/portfolio/ui/borrowingBase/portfolioBorrowingBaseChartConfigs';
import { PortfolioCoreBorrowingBaseChartTemplate } from 'packages/portfolio/ui/shared/PortfolioCoreBorrowingBaseChartTemplate';

export const BorrowingBaseContainerV2 = () => {
  const { creditFacilityId } = useCreditFacilityContext();

  return (
    <Flex direction="column" gap="2.5rem">
      {_.map(chartGroupMap.borrowingBase, (chart) => {
        return (
          <PortfolioCoreBorrowingBaseChartTemplate
            creditFacilityId={creditFacilityId}
            chartTitle={chart.chartTitle}
            chartConfig={chart.config}
            key={`portfolio-borrowing-base-chart-${chart.chartTitle}`}
          />
        );
      })}
    </Flex>
  );
};
